import CmsPage from "./CmsPage";

const About = () => {
  return <CmsPage slug="about" titleFallback="About" />;
};

export default About;
